<footer class="footer">
  <div class="row-footer">
    <div class="footer-column">
      <h3>{{ "menu.services" | translate }}</h3>
      <div>
        @for (item of serviceList; track $index) {
        <div>{{ item }}</div>
        }
      </div>
    </div>

    <div class="footer-column">
      <h3>{{ "menu.contact" | translate }}</h3>
      <div class="social-media">
        <a target="_blank" href="https://www.facebook.com/InduserviceFL/">
          <img src="assets/img/facebook.png" alt="facebook" />
        </a>
        <a
          target="_blank"
          class="p-1"
          href="https://www.instagram.com/induservice.fl/"
        >
          <img src="assets/img/instagram.png" alt="instagram" />
        </a>
        <a target="_blank" class="p-1" href="https://wa.me/573102228738">
          <img src="assets/img/wpp.png" alt="wpp" />
        </a>
      </div>
      <p>📞 {{ "contact.phone" | translate }}</p>
      <p>📧 {{ "contact.email" | translate }}</p>
      <p>📍 {{ "contact.address" | translate }}</p>
    </div>

    <div class="footer-column">
      <h3>{{ "footer.title" | translate }}</h3>
      <iframe
        title="Ubicación Induservice FL en Google Maps"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15837.998114212356!2d-73.1508073!3d7.0679329!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e683fe259f1840d%3A0x9eba2827925c5d81!2sInduservice%20F.L!5e0!3m2!1ses-419!2sco!4v1719618008172!5m2!1ses-419!2sco"
      ></iframe>
    </div>
  </div>
  <div>
    <p>&copy; {{ year }} {{ "footer.bottom" | translate }}</p>
  </div>
</footer>
